document.addEventListener('turbo:load', function(e) {
  
  /* --------------------------------------------------
                Create Map Radius
  -------------------------------------------------- */
  pgJobAnnouncementsNewMapRadius = function(){
    const googleMaps = document.getElementById('pages-job-announcements-new-map');
    if (!googleMaps) return;

    // Get job location
    const jobLat = parseFloat(googleMaps.dataset.lat);
    const jobLng = parseFloat(googleMaps.dataset.lng);

    // Get radius slider
    const radiusSlider = document.getElementById('pages-job-announcements-new-radius');
    const radiusValue = document.getElementById('pages-job-announcements-new-radius-value');
    const radiusInput = document.querySelector('input[name="job_announcement[radius]"]');

    // Set initial radius value
    if (radiusInput) {
      radiusInput.value = radiusSlider ? radiusSlider.value : 10;
    }

    // Create map
    const map = new google.maps.Map(googleMaps, {
      zoom: 10,
      center: { lat: jobLat, lng: jobLng },
      mapTypeControl: false,
      streetViewControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      mapId: 'job_announcement_map'
    });

    // Add radius circle to map
    const radiusCircle = new google.maps.Circle({
      strokeColor: '#000000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#000000',
      fillOpacity: 0.35,
      map: map,
      center: { lat: jobLat, lng: jobLng },
      radius: radiusInput ? radiusInput.value * 1609.34 : 16093.4,
      editable: false
    });

    // Add event listener to radius slider
    if (radiusSlider && radiusInput) {
      radiusSlider.addEventListener('input', function() {
        const miles = parseInt(this.value);
        const meters = miles * 1609.34;
        
        radiusCircle.setRadius(meters);
        if (radiusValue) {
          radiusValue.textContent = miles;
        }
        radiusInput.value = miles;
      });

      // Set initial circle radius based on slider value
      const initialMiles = parseInt(radiusSlider.value);
      radiusCircle.setRadius(initialMiles * 1609.34);
      if (radiusValue) {
        radiusValue.textContent = initialMiles;
      }
    }

    // Add marker to map
    const pinElement = new google.maps.marker.PinElement({
      scale: 1,
      background: '#000000',
      borderColor: '#FFFFFF',
      glyphColor: '#FFFFFF',
      glyph: '●'
    });

    new google.maps.marker.AdvancedMarkerElement({
      map: map,
      position: { lat: jobLat, lng: jobLng },
      title: 'Job Location',
      content: pinElement.element
    });
  }

  /* --------------------------------------------------
                Load Map Radius Google Maps API
  -------------------------------------------------- */
  pgJobAnnouncementsNewMapRadiusLoadGoogleMapsAPI = function() {
    if (typeof google !== 'undefined') {
      pgJobAnnouncementsNewMapRadius();
      return;
    }
    
    // Get map container
    const mapContainer = document.getElementById('pages-job-announcements-new-map');
    if (!mapContainer) return;
    
    // Get API key
    const apiKey = mapContainer.dataset.apiKey;
    const script = document.createElement('script');

    // Load Google Maps API
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap&libraries=marker&v=beta`;
    script.async = true;
    script.defer = true;

    // Initialize map
    window.initMap = function() {
      pgJobAnnouncementsNewMapRadius();
    };

    // Append script to head
    document.head.appendChild(script);
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pgJobAnnouncementsNewMapRadiusLoadGoogleMapsAPI();
});